export default "__VITE_ASSET__DI3VbulB__"